import './index.scss';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import React, { useState } from 'react';
import PermissionChecker from '~/components/permission_checker';
import Permissions from '~/settings/permissions';
import DocumentPanel from './document_panel';
import LeftPanel from './left_panel';
import { DocumentViewProvider, useDocumentView } from './providers';
const OldDocumentView = () => {
    const [isDocumentRendered, setIsDocumentRendered] = useState(false);
    const [activeClause, setActiveClause] = useState();
    const { isDocumentLoading, document } = useDocumentView();
    if (isDocumentLoading || !document) {
        return (React.createElement("div", { className: 'document-view-loading' },
            React.createElement(LoadingElement, { isLightBackground: true, large: true, text: 'Loading document...', heading: true })));
    }
    return React.createElement(PermissionChecker, { requiredAllPermissions: [Permissions.BROWSE_SINGLE_DOC] },
        React.createElement("div", { className: 'old-single-document-view page-content-wrapper' },
            React.createElement(LeftPanel, { activeClause: activeClause, document: document, isDocumentRendered: isDocumentRendered, setActiveClause: setActiveClause }),
            React.createElement(DocumentPanel, { activeClause: activeClause, document: document, isDocumentLoading: isDocumentLoading, setIsDocumentRendered: setIsDocumentRendered })));
};
const OldDocumentViewWrapper = () => {
    return React.createElement(DocumentViewProvider, null,
        React.createElement(OldDocumentView, null));
};
export default OldDocumentViewWrapper;
